import React, { useState, useEffect } from 'react';
import Scrollbar from '@/components/ui/scrollbar';
import NotFound from '@/components/ui/not-found';
import CategoriesLoader from '@/components/ui/loaders/categories-loader';
// import { isMobile } from 'react-device-detect';
import type { Category, Type } from '@/types';
import { checkIsMaintenanceModeComing } from '@/lib/constants';
import classNames from 'classnames';
import { useAtom } from 'jotai';
import { useTypes } from '@/framework/type';
import { TYPES_PER_PAGE } from '@/framework/client/variables';
import { NextRouter, useRouter } from 'next/router';
import { TreeGroupMenu } from './TreeMenu';
import { CustomCollapse } from './Collapse';

interface StickySidebarListCategoriesProps {
  notFound: boolean;
  loading: boolean;
  categories: Category[];
  full?: boolean;
  className?: string;
  hidden?: boolean;
}

export const StickySidebarListCategories: React.FC<
  StickySidebarListCategoriesProps
> = ({ notFound, loading, full, className, hidden = true }) => {
  const [underMaintenanceIsComing] = useAtom(checkIsMaintenanceModeComing);
  const router = useRouter() as NextRouter & { components: any };
  const { types: groups }: any = useTypes({
    limit: TYPES_PER_PAGE,
  });


  // On /categorias/[slug] pages the active category lives in router.query.slug.
  // On legacy /search pages with a refinement it may live in a query param, but
  // those are no longer linked from category pages, so we don't need to support it.
  const selectedCategorySlug = (router.query.slug as string) ?? '';

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (loading) {
    return (
      <div className={classNames(`${hidden ? 'hidden' : ''} xl:block`)}>
        <div className="mt-8 w-72 px-2">
          <CategoriesLoader />
        </div>
      </div>
    );
  }
  return (
    <aside
      className={classNames(
        `${hidden ? 'hidden' : ''} h-full bg-light lg:sticky xl:block ${
          full ? 'w-full' : 'xl:w-72'
        } ${className}`,
        underMaintenanceIsComing ? '' : 'lg:top-22',
      )}
    >
      <div className="max-h-full grow overflow-hidden">
        <Scrollbar
          className="max-h-screen w-full"
          style={{ height: 'calc(100vh - 5.35rem)' }}
        >
          <h4 className="text-color-primary text-xl px-5 py-4 font-semibold">
            Categorias
          </h4>
          {!notFound ? (
            isClient ? (
              <div className="px-5 pr-0">
                {groups?.map((group: Type, index: number) => (
                  <CustomCollapse
                    key={`${group.id}-group-${group.slug}`}
                    name={group.name}
                    icon={group.icon}
                  >
                    <TreeGroupMenu
                      key={`tree-menu-${index}`}
                      id={`${group.id}-${group.slug}`}
                      groupSlug={group.slug}
                      groupId={group.id}
                      parentKeyId={`scroll-bar-menu-group-${index}`}
                      selectedCategorySlug={selectedCategorySlug}
                    />
                  </CustomCollapse>
                ))}
              </div>
            ) : (
              ''
            )
          ) : (
            <div className="min-h-full w-full px-9 pt-6 pb-8 lg:p-8">
              <NotFound text="text-no-category" className="h-96" />
            </div>
          )}
        </Scrollbar>
      </div>
    </aside>
  );
};
